// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ns-0";